export default "__VITE_ASSET__2328da73__"